var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownarrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2931 8.29296C17.3853 8.19745 17.4957 8.12127 17.6177 8.06886C17.7397 8.01645 17.8709 7.98886 18.0037 7.98771C18.1365 7.98655 18.2681 8.01186 18.391 8.06214C18.5139 8.11242 18.6256 8.18667 18.7195 8.28056C18.8134 8.37446 18.8876 8.48611 18.9379 8.60901C18.9882 8.7319 19.0135 8.86358 19.0123 8.99636C19.0112 9.12914 18.9836 9.26036 18.9312 9.38236C18.8788 9.50437 18.8026 9.61471 18.7071 9.70696L12.7071 15.707C12.5248 15.8892 12.2793 15.9941 12.0216 15.9997C11.7639 16.0053 11.514 15.9111 11.3241 15.737L5.32407 10.237C5.12861 10.0577 5.01237 9.80808 5.00093 9.54309C4.99527 9.41188 5.0155 9.28084 5.06048 9.15745C5.10546 9.03407 5.1743 8.92074 5.26307 8.82396C5.35185 8.72718 5.45881 8.64882 5.57787 8.59338C5.69692 8.53793 5.82573 8.50648 5.95694 8.50082C6.22193 8.48938 6.48061 8.58367 6.67607 8.76296L11.9701 13.616L17.2931 8.29296Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownarrow);
export default __webpack_public_path__ + "static/media/dropdownarrow.7cd52b13526d6175d0c0ba40b32acc98.svg";
export { ForwardRef as ReactComponent };